module.exports = __webpack_public_path__ + "static/media/preparation_logo.b5c49504.svg";